import { gql } from '@apollo/client'

export const KUSTOMER_ARTICLE_VERSIONS = gql`
  query kustomerArticleVersions($query: String!) {
    kustomerArticleVersions(query: $query) {
      articleVersions {
        id
        htmlBody
        title
        category
      }
    }
  }
`
